import React from 'react';
import Row from 'components/row';
import Col from 'components/col';

module.exports = (props) => {
  var marker = props.marker || '*';
  return (
    <Row>
      <Col size="sm-12" className="aviso-preco">
        ({marker}) Atenção, informar o valor com os impostos (ICMS ST, IPI) e também frete (CIF) embutidos, ou seja, o valor final do produto e da embalagem informada.
      </Col>
    </Row>
  )
};


/** WEBPACK FOOTER **
 ** ./src/views/cotacao/aviso-preco.js
 **/